import HeaderComp from "./lib/Header";
import MenuComp from "./lib/Menu";
import CommercialBannerComp from "./lib/CommercialBanner";
import StatisticsComp from "./lib/Statistics";
import ServicesComp from "./lib/Services";
import CalculationComp from "./lib/Calculation";
import AnnouncementComp from "./lib/Announcement";
import PageHeaderComp from "./lib/PageHeader";
import CardItemComp from "./lib/CardItem";
import BultenItemComp from "./lib/BultenItem";
import FooterComp from "./lib/Footer";
import MarkerComp from "./lib/Marker";
import SliderComp from "./lib/slider/Slider";
import PostItemComp from "./lib/PostItem";
import CategoryItemComp from "./lib/CategoryItem";
import ColComp from "./lib/Col";
import LoaderComp from "./lib/Loader";
export const Loader = LoaderComp;
export const Header = HeaderComp;
export const Menu = MenuComp;
export const Slider = SliderComp;
export const CommercialBanner = CommercialBannerComp;
export const Statistics = StatisticsComp;
export const Services = ServicesComp;
export const Calculation = CalculationComp;
export const Announcement = AnnouncementComp;
export const Footer = FooterComp;
export const PageHeader = PageHeaderComp;
export const CardItem = CardItemComp;
export const Marker = MarkerComp;
export const PostItem = PostItemComp;
export const CategoryItem = CategoryItemComp;
export const BultenItem = BultenItemComp;
export const Col = ColComp;
